// eslint-disable-next-line
import React from 'react'; 
const App =(props)=> {
return (
<>{props.children}</>
);

}

export default App;